import Quotes from "../../../../src/posts/quotes/quotes.js";
import * as React from 'react';
export default {
  Quotes,
  React
};